import { ISiteBridgeSettingsForSiteAdmin } from '../../../settings/types/ISiteSettingsForSiteAdmin';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetSiteBridgeSettingsForSiteAdminParams {
  id: string;
}

export type IGetSiteBridgeSettingsForSiteAdminResult = IResult & ISiteBridgeSettingsForSiteAdmin;

export class GetSiteBridgeSettingsForSiteAdminRequest
  extends Request<IGetSiteBridgeSettingsForSiteAdminParams, IGetSiteBridgeSettingsForSiteAdminResult>
{
  constructor(params: IGetSiteBridgeSettingsForSiteAdminParams) {
    super('getSiteBridgeSettingsForSiteAdmin', params);
  }
}
